import { Button } from '@/shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import { Skeleton } from '@/shared/components/ui/skeleton'
import { useFeatureFlagsWithWorkspace } from '@/shared/hooks/useFeatureFlags'
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined'
import React, { ComponentProps } from 'react'

type VersionDropdownProps = {
  currentVersion: string
  totalVersions: number
  triggerProps?: ComponentProps<typeof DropdownMenuTrigger>
  contentProps?: ComponentProps<typeof DropdownMenuContent>
  isLoading?: boolean
}

export const VersionDropdown: React.FC<VersionDropdownProps> = ({
  isLoading,
  currentVersion,
  totalVersions,
  triggerProps,
  contentProps,
}) => {
  const { flags: [isVersionControlEnabled] } = useFeatureFlagsWithWorkspace([
    'playbookVersionControl',
  ])

  return isLoading ? (
    <Skeleton className="h-4 w-12 bg-grey-03 md:h-6" />
  ) : totalVersions <= 1 ? null : (
    <div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild {...triggerProps}>
          <Button variant="ghost" size="sm" className="h-6 cursor-pointer px-2">
            v{currentVersion}
            {isVersionControlEnabled && (
              <KeyboardArrowDownOutlined
                sx={{ fontSize: 12 }}
                className="ml-1"
              />
            )}
          </Button>
        </DropdownMenuTrigger>
        {isVersionControlEnabled && (
          <DropdownMenuContent {...contentProps} align="start">
            {Array.from({ length: totalVersions }, (_, index) => {
              const versionNumber = index + 1
              const isCurrentVersion =
                versionNumber.toString() === currentVersion
              return (
                <DropdownMenuItem
                  key={versionNumber}
                  className={`cursor-pointer ${isCurrentVersion ? 'bg-gray-100' : ''}`}
                >
                  Version {versionNumber}
                  {isCurrentVersion && (
                    <span className="ml-auto text-xs text-gray-500">
                      (current)
                    </span>
                  )}
                </DropdownMenuItem>
              )
            })}
          </DropdownMenuContent>
        )}
      </DropdownMenu>
    </div>
  )
}
